export const editorial = {
  "chapters": [
    {
      "key": "chapter1",
      "label": "I",
      "title": "Querida\nKitty",
      "meta": {
        "weekday": "Sábado",
        "day": "20",
        "month": "Junho",
        "year": "1942"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Tenho vontade de escrever e quero aliviar meu coração de todos os pesos.",
              "visual": "Tenho vontade de escrever e quero aliviar meu coração de todos os pesos.",
              "preset": "linear"
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "O papel é mais paciente do que os homens.",
              "visual": "“O PAPEL É MAIS PACIENTE\nDO QUE OS HOMENS.”",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Era nisso que eu pensava muitas vezes quando, nos meus dias melancólicos, colocava a cabeça entre as mãos sem saber o que fazer comigo mesma.",
              "visual": "Era nisso que eu pensava muitas vezes quando, nos meus dias melancólicos, colocava a cabeça entre as mãos sem saber o que fazer comigo mesma. [...]",
              "preset": "linear"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "É por tudo isso que escrevo um diário.",
              "visual": "É por tudo isso que escrevo um diário.",
              "preset": "linear"
            },
            {
              "spoken": "E, para trazer à minha imaginação a ideia da amiga que tanto tempo desejei ter, não quero simplesmente escrever os fatos, como qualquer pessoa.",
              "visual": "E, para trazer à minha imaginação a ideia da amiga que tanto tempo desejei ter, não quero simplesmente escrever os fatos, como qualquer pessoa.",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "Este diário será meu amigo, e vou dar um nome a ele. Esse diário se chamará Kitty.",
              "visual": "Este diário será meu amigo, e vou dar um nome a ele. Esse diário se chamará Kitty.",
              "preset": "linear",
              "flow": true
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter2",
      "label": "II",
      "title": "A\nconvocação",
      "meta": {
        "weekday": "quarta-feira",
        "day": "8",
        "month": "julho",
        "year": "1942"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Sozinhas no quarto, Margot me contou que a convocação não era para papai, mas para ela.",
              "visual": "Sozinhas no quarto, Margot me contou que a convocação não era para papai, mas para ela.",
              "preset": "linear"
            },
            {
              "spoken": "Fiquei ainda mais assustada e comecei a chorar.",
              "visual": "Fiquei ainda mais assustada e comecei a chorar.",
              "preset": "linear"
            },
            {
              "spoken": "Margot tem dezesseis anos. Será que eles levavam meninas dessa idade, sozinhas?",
              "visual": "Margot tem dezesseis anos. Será que eles levavam meninas dessa idade, sozinhas?",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "“Mergulhar!” Onde vamos nos esconder? Na cidade, no campo, em algum prédio, em uma cabana? Quando, como, onde?",
              "visual": "[...] “Mergulhar!” Onde vamos nos esconder? Na cidade, no campo, em algum prédio, em uma cabana? Quando, como, onde?",
              "preset": "linear"
            },
            {
              "spoken": "Eu não podia fazer essas perguntas em voz alta, mas elas não saíam da minha cabeça.",
              "visual": "Eu não podia fazer essas perguntas em voz alta, mas elas não saíam da minha cabeça.",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "Margot e eu começamos a colocar nas pastas da escola o que nos parecia mais necessário.",
              "visual": "Margot e eu começamos a colocar nas pastas da escola o que nos parecia mais necessário.",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "A primeira coisa que peguei foi este diário.",
              "visual": "A PRIMEIRA COISA QUE PEGUEI\nFOI ESTE DIÁRIO.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "As lembranças valem muito mais do que os vestidos.",
              "visual": "[...] As lembranças valem muito mais do que os vestidos.",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter3",
      "label": "III",
      "title": "Só por\nserem judeus,",
      "meta": {
        "weekday": "quinta-feira",
        "day": "19",
        "month": "novembro",
        "year": "1942"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Inúmeros amigos e conhecidos foram levados de suas casas para um destino terrível.",
              "visual": "inúmeros amigos e conhecidos foram levados de suas casas para um destino terrível.",
              "preset": "linear"
            },
            {
              "spoken": "Noite após noite, os automóveis cinzentos e verdes dos militares atravessam as ruas em alta velocidade.",
              "visual": "Noite após noite, os automóveis cinzentos e verdes dos militares atravessam as ruas em alta velocidade.",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "Os “verdes” e os “pretos” procuram os judeus. Se encontram alguém, levam essa pessoa e toda a sua família.",
              "visual": "Os “verdes” e os “pretos” procuram os judeus. Se encontram alguém, levam essa pessoa e toda a sua família.",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "Não poupam ninguém, homens, mulheres, idosos, crianças.",
              "visual": "NÃO POUPAM NINGUÉM,\nHOMENS, MULHERES,\nIDOSOS, CRIANÇAS.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "E nós aqui, tão protegidos! Poderíamos fechar os olhos para toda essa miséria, mas estamos sempre aflitos por aqueles que são queridos e a quem não podemos ajudar.",
              "visual": "[...] E nós aqui, tão protegidos! Poderíamos fechar os olhos para toda essa miséria, mas estamos sempre aflitos por aqueles que são queridos e a quem não podemos ajudar.",
              "preset": "linear"
            },
            {
              "spoken": "Quando estou deitada na minha cama, tão quente e confortável, enquanto minhas amigas mais queridas sofrem lá fora, talvez expostas ao vento e à chuva, até mortas, me sinto quase uma pessoa má.",
              "visual": "Quando estou deitada na minha cama, tão quente e confortável, enquanto minhas amigas mais queridas sofrem lá fora, talvez expostas ao vento e à chuva, até mortas, me sinto quase uma pessoa má.",
              "preset": "linear"
            },
            {
              "spoken": "E tudo isso só porque são judeus!",
              "visual": "[...] E tudo isso só porque são judeus!",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter4",
      "label": "IV",
      "title": "Um pedaço,\ndo céu",
      "meta": {
        "weekday": "sábado",
        "day": "26",
        "month": "fevereiro",
        "year": "1944"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Do meu lugar favorito no chão, vejo um pedaço de céu azul e o castanheiro sem folhas, cujos os galhos cintilam pequenas gotas, e vejo as gaivotas que, em seu voo planado, parecem feitas de prata.",
              "visual": "Do meu lugar favorito no chão, vejo um pedaço de céu azul e o castanheiro sem folhas, cujos os galhos cintilam pequenas gotas, e vejo as gaivotas que, em seu voo planado, parecem feitas de prata. [...]",
              "preset": "linear"
            },
            {
              "spoken": "“Enquanto ainda existe tudo isso”, pensei, um sol tão brilhante, um céu sem nuvens e tão azul,",
              "visual": "“Enquanto ainda existe tudo isso”, pensei, um sol tão brilhante, um céu sem nuvens e tão azul,",
              "preset": "linear"
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "E enquanto me é dado ver e viver tamanha beleza, não devo estar triste.",
              "visual": "E ENQUANTO ME É DADO VER\nE VIVER TAMANHA BELEZA,\nNÃO DEVO ESTAR TRISTE.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Para qualquer pessoa que se sinta só ou infeliz, ou que esteja preocupada, o melhor remédio é sair ao ar livre, ir para algum lugar onde possa estar a sós com o céu, com a natureza e com Deus”.",
              "visual": "Para qualquer pessoa que se sinta só ou infeliz, ou que esteja preocupada, o melhor remédio é sair ao ar livre, ir para algum lugar onde possa estar a sós com o céu, com a natureza e com Deus”.",
              "preset": "linear"
            },
            {
              "spoken": "Acredito que a natureza alivia os sofrimentos.",
              "visual": "[...] Acredito que a natureza alivia os sofrimentos.",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter5",
      "label": "V",
      "title": "Escrever\npara\nrespirar",
      "meta": {
        "weekday": "quinta-feira",
        "day": "16",
        "month": "março",
        "year": "1944"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Uma vez ali com você, Kitty, posso, por um breve momento, ser eu mesma.",
              "visual": "Uma vez ali com você, Kitty, posso, por um breve momento, ser eu mesma. [...]",
              "preset": "linear"
            },
            {
              "spoken": "Não se esqueça: vivo em uma época louca e em circunstâncias loucas.",
              "visual": "Não se esqueça: vivo em uma época louca e em circunstâncias loucas.",
              "preset": "linear"
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "Que sorte a minha poder escrever o que penso e sinto.",
              "visual": "QUE SORTE A MINHA\nPODER ESCREVER\nO QUE PENSO E SINTO.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Se não fosse por isso, certamente sufocaria.",
              "visual": "Se não fosse por isso, certamente sufocaria. [...]",
              "preset": "linear"
            },
            {
              "spoken": "Se eu pudesse escrever para ele! Assim, ele saberia o que eu gostaria de dizer. Mas falar é muito difícil!",
              "visual": "Se eu pudesse escrever para ele! Assim, ele saberia o que eu gostaria de dizer. Mas falar é muito difícil!",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter6",
      "label": "VI",
      "title": "Oito\ncorações",
      "meta": {
        "weekday": "terça-feira",
        "day": "11",
        "month": "abril",
        "year": "1944"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Estávamos sentadas no escuro e, sempre que se ouvia algum ruído, murmurávamos “shh, silêncio”.",
              "visual": "Estávamos sentadas no escuro [...] e, sempre que se ouvia algum ruído, murmurávamos “shh, silêncio”. [...]",
              "preset": "linear"
            },
            {
              "spoken": "Ouvimos ruídos lá embaixo. Agora já se ouvia a respiração de cada um de nós. Não nos mexíamos.",
              "visual": "Ouvimos ruídos lá embaixo. Agora já se ouvia a respiração de cada um de nós. Não nos mexíamos.",
              "preset": "linear"
            },
            {
              "spoken": "Passos na casa, no escritório particular, na cozinha, depois... Na escada que leva à porta camuflada.",
              "visual": "Passos na casa, no escritório particular, na cozinha, depois... Na escada que leva à porta camuflada.",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "Prendemos a respiração; oito corações batendo forte.",
              "visual": "PRENDEMOS A RESPIRAÇÃO;\nOITO CORAÇÕES BATENDO FORTE.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Passos na escada, barulhos nas prateleiras da porta giratória. Esses momentos são impossíveis de descrever.",
              "visual": "Passos na escada, barulhos nas prateleiras da porta giratória. Esses momentos são impossíveis de descrever.",
              "preset": "linear"
            },
            {
              "spoken": "“Estamos perdidos”, pensei, e já imaginava todos nós sendo arrastados pela Gestapo no meio da noite.",
              "visual": "“Estamos perdidos”, pensei, e já imaginava todos nós sendo arrastados pela Gestapo no meio da noite.",
              "preset": "linear",
              "flow": true
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter7",
      "label": "VII",
      "title": "Apesar\nde tudo",
      "meta": {
        "weekday": "sábado",
        "day": "15",
        "month": "julho",
        "year": "1944"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Essa é a dificuldade do nosso tempo: mal começam a germinar em nós ideais, sonhos e belas esperanças, a realidade cruel se apodera de tudo isso para destruir completamente.",
              "visual": "Essa é a dificuldade do nosso tempo: mal começam a germinar em nós ideais, sonhos e belas esperanças, a realidade cruel se apodera de tudo isso para destruir completamente.",
              "preset": "linear"
            },
            {
              "spoken": "É um milagre que eu ainda não tenha renunciado a todas as minhas esperanças, que, na verdade, são tão absurdas e impossíveis de realizar.",
              "visual": "É um milagre que eu ainda não tenha renunciado a todas as minhas esperanças, que, na verdade, são tão absurdas e impossíveis de realizar.",
              "preset": "linear"
            },
            {
              "spoken": "Mas eu me agarro a elas, apesar de tudo e de todos,",
              "visual": "Mas eu me agarro a elas, apesar de tudo e de todos,",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "Porque tenho fé no que há de bom no homem.",
              "visual": "PORQUE TENHO FÉ NO QUE\nHÁ DE BOM NO HOMEM.",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Não consigo construir minha vida tendo como base a morte, a miséria e a confusão.",
              "visual": "Não consigo construir minha vida tendo como base a morte, a miséria e a confusão.",
              "preset": "linear"
            },
            {
              "spoken": "Vejo o mundo se transformar, pouco a pouco, em um deserto;",
              "visual": "Vejo o mundo se transformar, pouco a pouco, em um deserto;",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "ouço, cada vez mais forte, a trovoada que se aproxima, essa trovoada que vai nos matar;",
              "visual": "ouço, cada vez mais forte, a trovoada que se aproxima, essa trovoada que vai nos matar;",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "sinto o sofrimento de milhões de pessoas e, mesmo assim, quando ergo os olhos para o céu, penso que, um dia, tudo isso voltará a ser bom,",
              "visual": "sinto o sofrimento de milhões de pessoas e, mesmo assim, quando ergo os olhos para o céu, penso que, um dia, tudo isso voltará a ser bom,",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "que a crueldade chegará ao fim e que o mundo voltará a conhecer a ordem, a paz e a tranquilidade.",
              "visual": "que a crueldade chegará ao fim e que o mundo voltará a conhecer a ordem, a paz e a tranquilidade.",
              "preset": "linear",
              "flow": true
            },
            {
              "spoken": "Até lá, preciso manter meus ideais firmes — talvez ainda possa realizá-los nos tempos que virão.",
              "visual": "Até lá, preciso manter meus ideais firmes — talvez ainda possa realizá-los nos tempos que virão.",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": null
    },
    {
      "key": "chapter8",
      "label": "VIII",
      "title": "As duas\nAnnes",
      "meta": {
        "weekday": "terça-feira",
        "day": "1",
        "month": "agosto",
        "year": "1944"
      },
      "blocks": [
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Já contei outras vezes que não tenho apenas uma alma, mas duas.",
              "visual": "Já contei outras vezes que não tenho apenas uma alma, mas duas.",
              "preset": "linear"
            },
            {
              "spoken": "Uma delas é a minha alegria exuberante, minhas zombarias a propósito de tudo, minha vontade de viver e minha tendência a levar tudo na brincadeira.",
              "visual": "Uma delas é a minha alegria exuberante, minhas zombarias a propósito de tudo, minha vontade de viver e minha tendência a levar tudo na brincadeira.",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "Essa primeira alma está sempre à espreita e faz de tudo para tomar o lugar da outra, que é mais bela, mais pura, mais profunda.",
              "visual": "[...] Essa primeira alma está sempre à espreita e faz de tudo para tomar o lugar da outra, que é mais bela, mais pura, mais profunda.",
              "preset": "linear"
            },
            {
              "spoken": "Essa alma boa da Anne ninguém conhece, não é verdade?",
              "visual": "Essa alma boa da Anne ninguém conhece, não é verdade?",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "É por isso que a Anne terna e simpática nunca vem à tona na presença de outras pessoas, mas é a sua voz que domina quando estou sozinha.",
              "visual": "[...] É por isso que a Anne terna e simpática nunca vem à tona na presença de outras pessoas, mas é a sua voz que domina quando estou sozinha.",
              "preset": "linear"
            },
            {
              "spoken": "Sei exatamente como gostaria de ser, sei como sou... No meu íntimo, mas, infelizmente, só sou assim quando estou sozinha comigo mesma.",
              "visual": "Sei exatamente como gostaria de ser, sei como sou... No meu íntimo, mas, infelizmente, só sou assim quando estou sozinha comigo mesma. [...]",
              "preset": "linear",
              "flow": true
            }
          ]
        },
        {
          "role": "highlight",
          "fragments": [
            {
              "spoken": "E continuo procurando um meio de me tornar aquela que gostaria de ser,",
              "visual": "E CONTINUO PROCURANDO UM\nMEIO DE ME TORNAR AQUELA\nQUE GOSTARIA DE SER,",
              "preset": "blurry"
            }
          ]
        },
        {
          "role": "body",
          "fragments": [
            {
              "spoken": "que eu seria capaz de ser, se... sim, se não houvesse mais ninguém no mundo.",
              "visual": "que eu seria capaz de ser, se... sim, se não houvesse mais ninguém no mundo.",
              "preset": "linear"
            }
          ]
        }
      ],
      "afterword": {
        "text": "TUA ANNE FRANK"
      }
    }
  ],
  "intro": {
    "titleLines": [
      "ESTE LIVRO",
      "SÓ SE REVELA",
      "QUANDO VOCÊ",
      "LÊ EM VOZ ALTA."
    ],
    "body": "Enquanto tiver quem dê voz a uma história, ela jamais vai ser esquecida. Os horrores do Holocausto calaram a voz de Anne Frank em 1945. Mas o diário que ela deixou para atrás, não pode ser calado. Ele precisa de uma nova voz. A sua voz. Leia em voz alta. Porque essa história real, ninguém nunca deve esquecer."
  },
  "closing": {
    "meta": {
      "weekday": "DEZEMBRO",
      "day": "DE",
      "month": "",
      "year": "2026"
    },
    "groups": [
      "Esta foi a última vez que\nAnne escreveu em seu diário.\nTrês dias depois, o esconderijo\nfoi descoberto.",
      "Mas sua voz não parou.\nVocê acabou de mantê-la viva."
    ]
  }
};
